module.exports = __webpack_public_path__ + "img/23-4.4e6358cf.png";